﻿(function () {
    function lazyPreload(entries) {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                const carousel = entry.target;
                carousel?.querySelectorAll('.carousel-item img').forEach(img => img.classList.add("lazypreload"));
            }
        });
    }

    const options = {
        root: null,        // Viewport
        rootMargin: '0px', // Same as the margin CSS property, here you could add margin for the top menu
        threshold: 0       // 0 - 1 (0 - 100% visibility before kicking in)
    }

    const observer = new IntersectionObserver(lazyPreload, options);

    const slideShows = document.querySelectorAll(".carousel-inner");
    slideShows.forEach((sh) => observer.observe(sh));
})();
